export default {
  mySetting_nickName: 'Nickname:',
  mySetting_switch_home: 'Toggle homepage',
}
